import React, { createContext, useContext, useState, useCallback } from "react";

const TRANSLATIONS = {
  it: {
    nav: { work: "Galleria", services: "Servizi", about: "Anna", contact: "Contatti" },
    cta: { call: "Chiama", whatsapp: "WhatsApp", book: "Prenota su WhatsApp" },
    hero: {
      kicker: "Parrucchiera — Villesse (GO)",
      l1: "Perché ogni",
      l2: "giorno è un",
      l3: "giorno speciale.",
      lead:
        "Colore, schiariture e acconciature disegnate su di te. Nel salone di Anna ogni testa è un piccolo capolavoro.",
      scroll: "Scorri",
    },
    marquee: ["Colore", "Balayage", "Sposa", "Colori Creativi", "Piega", "Uomo", "Trattamenti"],
    manifesto: {
      kicker: "Il nostro credo",
      chapters: [
        { n: "01", t: "Voglia di cambiare", d: "Un nuovo colore, una nuova luce. Ascoltiamo cosa vuoi e lo rendiamo reale, ciocca dopo ciocca." },
        { n: "02", t: "Voglia di ricominciare", d: "Schiariture, polverini ed effetti naturali per un biondo luminoso senza rovinare il capello." },
        { n: "03", t: "Voglia di nuovo", d: "Dal rosso intenso ai colori creativi: osiamo insieme, con tecnica e passione." },
      ],
    },
    services: {
      kicker: "Cosa facciamo",
      title: "Servizi",
      lead: "Ogni servizio è pensato per esaltare la tua personalità.",
      items: [
        { n: "01", t: "Taglio & Piega", d: "Tagli su misura e pieghe che durano, per ogni tipo di capello." },
        { n: "02", t: "Colore", d: "Colorazioni ricche e uniformi, dal naturale al rosso intenso." },
        { n: "03", t: "Schiariture & Balayage", d: "Polverini ed effetti naturali per un biondo dolce e luminoso." },
        { n: "04", t: "Colori Creativi", d: "Rosa, blu, arancio: fantasia senza limiti, tecnica al primo posto." },
        { n: "05", t: "Sposa & Acconciature", d: "Raccolti e styling per il tuo giorno più importante." },
        { n: "06", t: "Uomo", d: "Tagli maschili, sfumature e colore su misura." },
      ],
    },
    gallery: {
      kicker: "Prima / Dopo",
      title: "Galleria",
      lead: "Lavori reali realizzati nel salone. Ogni foto è un cambiamento vero.",
    },
    about: {
      kicker: "Chi c'è dietro",
      title: "Anna",
      p1: "Carpe Diem nasce dalla passione di Anna per il colore e la cura del capello. Nel salone di Villesse ogni cliente trova ascolto, tecnica e un risultato costruito insieme.",
      p2: "Dalle schiariture più naturali ai colori creativi più audaci, l'obiettivo è sempre lo stesso: farti uscire con il sorriso e con capelli sani e luminosi.",
      stats: [
        { k: "20+", v: "Anni di esperienza" },
        { k: "100%", v: "Su misura" },
        { k: "Villesse", v: "Cuore del Friuli" },
      ],
    },
    contact: {
      kicker: "Passa a trovarci",
      title: "Prenota il tuo appuntamento",
      lead: "Chiama per fissare, oppure scrivici su WhatsApp: ti rispondiamo appena possibile.",
      addressLabel: "Dove siamo",
      hoursLabel: "Orari",
      hours: [
        { d: "Martedì", h: "09:00 — 17:00" },
        { d: "Sabato", h: "08:00 — 17:00" },
        { d: "Altri giorni", h: "Su appuntamento" },
      ],
      callLabel: "Telefono",
      waLabel: "WhatsApp",
    },
    footer: { rights: "Tutti i diritti riservati.", made: "Ogni giorno è un giorno speciale." },
  },
  en: {
    nav: { work: "Gallery", services: "Services", about: "Anna", contact: "Contact" },
    cta: { call: "Call", whatsapp: "WhatsApp", book: "Book on WhatsApp" },
    hero: {
      kicker: "Hair Salon — Villesse (GO), Italy",
      l1: "Because every",
      l2: "day is a",
      l3: "special day.",
      lead:
        "Colour, lightening and styling designed around you. In Anna's salon every head becomes a small masterpiece.",
      scroll: "Scroll",
    },
    marquee: ["Colour", "Balayage", "Bridal", "Creative Colour", "Blow-dry", "Men", "Treatments"],
    manifesto: {
      kicker: "What we believe",
      chapters: [
        { n: "01", t: "A wish to change", d: "A new colour, a new light. We listen to what you want and make it real, strand by strand." },
        { n: "02", t: "A wish to restart", d: "Lightening and natural effects for a luminous blonde without damaging your hair." },
        { n: "03", t: "A wish for something new", d: "From deep reds to bold creative colours: we dare together, with craft and passion." },
      ],
    },
    services: {
      kicker: "What we do",
      title: "Services",
      lead: "Every service is crafted to bring out your personality.",
      items: [
        { n: "01", t: "Cut & Styling", d: "Tailored cuts and lasting blow-dries for every hair type." },
        { n: "02", t: "Colour", d: "Rich, even colour, from natural tones to deep intense reds." },
        { n: "03", t: "Highlights & Balayage", d: "Soft, natural techniques for a sweet, luminous blonde." },
        { n: "04", t: "Creative Colour", d: "Pink, blue, orange: no limits to imagination, craft always first." },
        { n: "05", t: "Bridal & Updos", d: "Updos and styling for your most important day." },
        { n: "06", t: "Men", d: "Men's cuts, fades and tailored colour." },
      ],
    },
    gallery: {
      kicker: "Before / After",
      title: "Gallery",
      lead: "Real work done in the salon. Every photo is a real transformation.",
    },
    about: {
      kicker: "Behind the chair",
      title: "Anna",
      p1: "Carpe Diem is born from Anna's passion for colour and hair care. In the Villesse salon every client finds a good ear, real craft and a result built together.",
      p2: "From the most natural lightening to the boldest creative colours, the goal is always the same: to send you out smiling, with healthy, shining hair.",
      stats: [
        { k: "20+", v: "Years of experience" },
        { k: "100%", v: "Tailored" },
        { k: "Villesse", v: "Heart of Friuli" },
      ],
    },
    contact: {
      kicker: "Come and see us",
      title: "Book your appointment",
      lead: "Call to book, or message us on WhatsApp: we reply as soon as we can.",
      addressLabel: "Where we are",
      hoursLabel: "Hours",
      hours: [
        { d: "Tuesday", h: "09:00 — 17:00" },
        { d: "Saturday", h: "08:00 — 17:00" },
        { d: "Other days", h: "By appointment" },
      ],
      callLabel: "Phone",
      waLabel: "WhatsApp",
    },
    footer: { rights: "All rights reserved.", made: "Every day is a special day." },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const toggle = useCallback(() => setLang((l) => (l === "it" ? "en" : "it")), []);
  const t = TRANSLATIONS[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useI18n = () => useContext(LanguageContext);
